import { DELETE_NOTIFICATION_TOKEN, Logout } from "./Functions";

const toLogin = () => window.location.replace("/login");

export const signOut = async (leave = toLogin) => {
  try {
    await DELETE_NOTIFICATION_TOKEN();
  } catch (e) {
    // Logging out must never wait on the server forgetting this browser's alerts.
  }
  Logout();
  leave();
};
